import { render, staticRenderFns } from "./DetailsSection.vue?vue&type=template&id=63db9da2&scoped=true"
import script from "./DetailsSection.vue?vue&type=script&lang=js"
export * from "./DetailsSection.vue?vue&type=script&lang=js"
import style0 from "./DetailsSection.vue?vue&type=style&index=0&id=63db9da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db9da2",
  null
  
)

export default component.exports